export default __webpack_public_path__ + "static/blog-6-e9bf3ce3bbb9a5a635cf63cd449b5837.jpg";